<ng-container *ngFor="let col of columns">
    <span *ngIf="col.name == 'options' || !isValueExist(col.name) then noStandardCol else standardCol"></span>

    <ng-template #standardCol>
        <td>{{values[col.name] | number: '1.0-3' | removeComma}}</td>
    </ng-template>

    <ng-template #noStandardCol>
        <ng-container *ngIf="col.name == 'options' else emptyCell">
            <td class="options-row-cell cursor-pointer" (click)="openSettings.emit();">
                <i *ngIf="!isSummaryLoading" class="pi pi-bars"></i>
                <i *ngIf="isSummaryLoading" class="pi pi-spin pi-spinner"
                    matTooltip="{{'loadingSummaryInfo' | translate}}"></i>
            </td>
        </ng-container>
        <ng-template #emptyCell>
            <td></td>
        </ng-template>
    </ng-template>
</ng-container>